import React from 'react';
import { Paper, Tooltip, Typography } from '@mui/material';

const ReportMetricCard = ({
  label,
  value,
  tooltip,
  paperSx = {},
  labelSx = {},
  valueSx = {},
}) => (
  <Tooltip title={tooltip} arrow placement="top">
    <Paper sx={{ p: 2.5, borderRadius: 2, bgcolor: '#FFFFFF', border: '1px solid #E8CDCC', ...paperSx }}>
      <Typography variant="body2" color="text.secondary" sx={labelSx}>
        {label}
      </Typography>
      <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5, ...valueSx }}>
        {value}
      </Typography>
    </Paper>
  </Tooltip>
);

export default ReportMetricCard;
